module.exports = function (fox) {
    'use strict';

    require('../../../../common-components/consent')(fox);
    require('./widget/consent')(fox);
    require('./widget/page')(fox);

    require('fox-dynamic-injection!fox-template-loader!./templates/popup.tpl')(fox);
    require('./stylus/styles.styl');
};


// WEBPACK FOOTER //
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/admin/common/components/consent/index.es.js